import SessionFetchedEvent from 'javascripts/layouts/v2/SessionFetchedEvent'

window.addEventListener('DOMContentLoaded', () => {
  // セッション情報取得後に、お気に入り・応募済み案件の状態を更新します。
  document.addEventListener('session:fetched', (event: SessionFetchedEvent) => {
    const session = event.detail.session

    document.querySelectorAll('.card.job-card').forEach((card: HTMLDivElement) => {
      const job_offer_id = Number(card.dataset.jobOfferId)

      // お気に入り
      if (session.favorite_job_offer_ids.includes(job_offer_id)) {
        const btn: HTMLAnchorElement = card.querySelector('.favorite-btn')
        btn.classList.add('active')
        btn.dataset.method = 'delete'
      }

      // 応募済み
      if (session.user?.applied_job_offer_ids.includes(job_offer_id)) {
        const label = card.querySelector('.status_label.-application')
        label.ariaHidden = 'false'
      }
    })
  })
})
